<template>
  <CCard class="dataTable py-5 mt-1">
    <CRow class="pt-2 pb-4">
      <CCol sm="12" class="d-flex flex-column">
        <div>
          <h2 class="titlePage font-weight-normal text-capitalize">
            {{ campaign.name }}
          </h2>
        </div>
      </CCol>
    </CRow>
    <CRow class="mt-3 mb-4">
      <CCol>
        <a
          @click="backToReport()"
          class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600"
          style="cursor: pointer"
        >
          <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
          {{ $t('campaign.campaignResume.link.backToList') }}
        </a>
      </CCol>
    </CRow>
    <CRow class="mt-3 mb-4">
      <CCol>
        <div>
          <h2 class="titlePage font-weight-normal text-capitalize">
            {{ title }}
          </h2>
        </div>
      </CCol>
    </CRow>

    <CCardHeader class="dataTable__header d-flex justify-content-between px-0 pb-3">
      <div class="dataTable__countContants">
        <h3 class="font-weight-normal text-gray-700 mt-3 d-flex align-items-sm-center">
          {{ totalRecords || 0 }}
          <span class="font-sm font-weight-normal text-uppercase ml-2">{{ $t('campaign.campaignResume.text.contact') }}</span>
        </h3>
      </div>
      <div class="dataTable__search">
        <CInput
          type="search"
          :placeholder="$t('campaign.campaignResume.placeholder.search')"
          addInputClasses="pl-5"
          class="iconSearchPlaceholder pb-0"
          v-model="searchName"
          @input="searchByName()"
        >
        </CInput>
      </div>
      <div class="dataTable__buttonLink">
        <CButton
          v-if="isCurrentOrganizationBase"
          :disabled="showPopupExport || !registers || registers.length == 0"
          size="md"
          class="btn btn-primary px-5 py-3 font-weight-bold"
          tag="button"
          @click="() => (showPopupExport = true)"
        >
          {{ $t('campaign.campaignResume.button.export') }}
          <CIcon name="arrowExport" size="custom-size" :height="18" class="ml-2" viewBox="0 0 32 32" />
        </CButton>
        <transition name="fade" v-if="showPopupExport">
          <div class="dataTable__popUp popUp" @click.stop.stop>
            <div class="popUp__body shadow-sm">
              <ChooseExport v-show="showPopupExport" :totalRecords="totalRecords" @confirm="exportData" @cancel="() => (showPopupExport = false)" />
            </div>
          </div>
        </transition>
      </div>

      <!-- <button @click="testeAcc">acc</button> -->
    </CCardHeader>

    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>

    <template>
      <CCardBody class="dataTable__body p-0">
        <CDataTable
          :items="registers"
          :fields="headers"
          :table-filter="{ external: true, lazy: true }"
          items-per-page-select
          @row-clicked="(item) => check(item)"
          :items-per-page.sync="itemsPerPage"
          @pagination-change="paginationChange"
          :active-page="1"
          hover
          :loading="loading"
        >
          <template #loading>
            <div class="d-flex justify-content-center align-items-center dataTable__loading">
              <CSpinner class="my-3" color="primary" />
            </div>
          </template>
          <template #no-items-view>
            <slot name="no-items">
              <CCol xs="12" sm="6" class="offset-sm-3 text-center emptyCard d-flex flex-column content-center justify-content-center">
                <div>
                  <figure class="mb-5">
                    <img src="/img/site/amico.png" alt="" width="181" />
                  </figure>
                  <h3 class="mb-3">
                    {{ $t('invoices.list.table.empty.title') }}
                  </h3>
                  <p class="px-5 text-gray-700">
                    {{ $t('invoices.list.table.empty.description') }}
                  </p>
                </div>
              </CCol>
            </slot>
          </template>
          <template #countryId="{ item }">
            <td>
              <div class="d-flex">
                <img :src="getFlag(item.countryId).flag" width="25" height="auto" class="mr-2" />
                {{ getFlag(item.countryId).label }}
              </div>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </template>

    <CPagination v-show="pages > 0" align="center" :pages="pages" :active-page.sync="activePage" class="dataTable__newPagination mt-3">
      <template slot="previous-button">
        <span class="newPagination__button p-2 btnPagination">
          {{ $t('audience.audienceList.text.prev') }}
        </span>
      </template>
      <template slot="next-button">
        <span class="newPagination__button p-2 btnPagination">
          {{ $t('audience.audienceList.text.next') }}
        </span>
      </template>
    </CPagination>
  </CCard>
</template>

<script>
import MenssageAlert from '@/components/MenssageAlert'
import { dateTimeFormatString } from '../../../utils/dateUtil'
import { getFilenameFromContentDisposition } from '../../../utils/responseHeaderUtils'
import services from '@/services.js'
import fileDownload from 'js-file-download'
import ChooseExport from '@/components/ChooseExport'
import { nameCountries } from '@/utils/countriesUtils.js'
import { mapGetters } from 'vuex'

var defaultEmailHeaders = {
  uniqueopens: ['email', 'open', 'click', 'sender', 'sentDate'],
  clicks: ['email', 'open', 'clicks', 'sender', 'sentDate'],
  bounced: ['email', 'bounced', 'sender', 'sentDate', 'error', 'error_related_to'],
  markedasspam: ['email'],
  unsubscribes: ['email', 'open', 'click', 'sender', 'sentDate'],
  recipients: ['sender', 'email'],
}

var defaultSMSHeaders = {
  pending: ['phone', 'countryId', 'sender', 'message', 'sentDate', 'status', 'deliveryDate', 'deliveryDescription', 'totalSegments'],
  delivered: ['phone', 'countryId', 'sender', 'message', 'sentDate', 'status', 'deliveryDate', 'deliveryDescription', 'totalSegments'],
  notdelivered: ['phone', 'countryId', 'sender', 'message', 'sentDate', 'status', 'deliveryDate', 'deliveryDescription', 'totalSegments'],
}

var dlrStatus = {
  0: 'Delivered',
  1: 'Pending',
  2: 'Not Delivered',
}

var titlesPages = {
  uniqueopens: 'Unique Opens',
  clicks: 'Clicks',
  bounced: 'Bounced',
  markedasspam: 'Spam',
  unsubscribes: 'Unsubscribes',
  pending: 'Pending',
  delivered: 'Delivered',
  notdelivered: 'Not delivered',
}

export default {
  name: 'CampaignResume',
  components: {
    MenssageAlert,
    ChooseExport,
  },
  data() {
    return {
      dateTimeFormatString: dateTimeFormatString,
      timezone: null,
      columnFilterValue: {},
      showPopupExport: false,
      campaign: {},
      observer: true,
      tableFilterValue: null,
      loadedItems: [],
      loading: false,
      itemsListSelected: null,
      responsive: false,
      messages: [],
      filters: {
        Page: 1,
        Count: 10,
        Status: [],
      },
      title: '',
      searchTimeout: null,
      searchName: null,
      // PAGINAÇÃOA
      pages: 0,
      activePage: 1,
      totalRecords: 0,
      totalPages: 0,
      itemsPerPage: 10,
      registers: [],
    }
  },

  created() {
    if (!this.headers || this.headers.length === 0) {
      this.$router.push({
        name: 'campaignResult',
        params: { campaignId: this.$route.params.campaignId },
      })
    }
  },

  mounted() {
    this.getData()
    this.getCampaignResult(this.$route.params.campaignId)
    // this.filterList()
    this.title = titlesPages[this.$route.params.type]
  },

  watch: {
    reloadParams() {
      this.onTableChange()
    },
  },

  computed: {
    ...mapGetters({
      isOrganizationBase: 'auth/isOrganizationBase',
    }),

    isCurrentOrganizationBase() {
      return this.isOrganizationBase(this.$route.params.organizationId)
    },

    headers() {
      const defaultHeaders = this.$route.params.scheduleType == 'email' ? defaultEmailHeaders : defaultSMSHeaders
      const translationRefArr = defaultHeaders[this.$route.params.type]
      const headers = []
      translationRefArr.forEach((ref) => {
        const headerObj = {
          key: ref,
          label: this.$t(`campaign.resume.headers.${ref}`),
        }
        headers.push(headerObj)
      })

      return headers
    },
    hasAudience() {
      return this.$store.state.audience.hasAudience
    },

    itemsPending() {
      return 0
      // return this.loadedItems.find(item => item.statusIdto == 1)
    },

    showApproveRefuse() {
      // só mostra a featuea de aprovação se  status por pedding
      const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
      return item ? item.statusId == 1 : null // 1 == pedding
    },

    showAssociate() {
      // só mostra a feature de associaçao se  status por approved
      const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
      return item ? item.statusId == 2 : null // 2 == approved
    },

    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue, this.SenderStatusId, this.OrganizationStatusId]
    },
  },

  methods: {
    backToReport() {
      this.$router.push({
        name: 'campaignResult',
        params: { campaignId: this.$route.params.campaignId },
      })
    },

    searchByName() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        let scheduleType = this.$route.params.scheduleType == 'email' ? this.$route.params.scheduleType : 'msisdn'

        this.filters[scheduleType] = this.searchName
        this.onTableChange()
      }, 700)
    },

    exportData(body) {
      let scheduleType = this.$route.params.scheduleType
      let scheduleId = this.$route.params.scheduleId
      let type = this.$route.params.type
      this.showPopupExport = false

      // if (type == 'clicks') {
      //   type = 'uniqueclicks'
      // }
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId
      services
        .getCampaignResumeDownload(organizationId, scheduleType, scheduleId, type, body)
        .then((response) => {
          const nameFile = getFilenameFromContentDisposition(response.headers['content-disposition'])

          fileDownload(response.data, nameFile, response.headers['content-type'])
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message || response.statusText,
          })
        })
    },

    setRegistersByType(type, res) {
      switch (type) {
        case 'uniqueopens':
          this.registers = this.editUniqueOpens(res.data.data.recipients)
          break
        case 'clicks':
          this.registers = this.editClicks(res.data.data.recipients)
          break
        case 'uniqueclicks':
          this.registers = this.editUniqueClicks(res.data.data.recipients)
          break
        case 'bounced':
          this.registers = this.editBounced(res.data.data.recipients)
          break
        case 'markedasspam':
          this.registers = this.editMarkedAsSpam(res.data.data.recipients)
          break
        case 'unsubscribes':
          this.registers = this.editUnsubscribes(res.data.data.recipients)
          break
        case 'pending':
          this.registers = this.editPending(res.data.data.recipients)
          break
        case 'delivered':
          this.registers = this.editDelivered(res.data.data.recipients)
          break
        case 'notdelivered':
          this.registers = this.editNotDelivered(res.data.data.recipients)
          break
        case 'recipients':
          this.registers = this.editRecipients(res.data.data)
          break
        default:
          this.registers = []
          this.totalRecords = 0
      }
    },

    async getData() {
      try {
        this.loading = true
        const scheduleType = this.$route.params.scheduleType
        const scheduleId = this.$route.params.scheduleId
        const type = this.$route.params.type
        this.filters.Page = this.activePage
        const organizationId = this.$store.state.auth.organizationId
        let response

        if (type === 'recipients') {
          if (scheduleType === 'email') {
            response = await services.getCampaignRecipientsEmail(organizationId, scheduleId, this.filters)
          }
          if (scheduleType === 'sms') {
            response = await services.getCampaignRecipientsSMS(organizationId, scheduleId, this.filters)
          }
        } else {
          response = await services.getCampaignResume(organizationId, scheduleType, scheduleId, type, this.filters)

          const pagination = response.data.data.pagination
          this.totalRecords = response.data.data.pagination.totalRecords
          this.filters.Page = pagination.currentPage
          this.pages = pagination.totalPages
          this.timezone = response.data.data.timezone
        }

        this.setRegistersByType(type, response)
      } catch (error) {
        this.loadedItems = []
        this.totalRecords = 0
      } finally {
        this.loading = false
      }
    },

    getCampaignResult(campaignId) {
      let organizationId = this.$store.state.auth.organizationId
      services.getCampaignResult(organizationId, campaignId).then((res) => {
        this.campaign = JSON.parse(JSON.stringify(res.data.data))
      })
    },

    editUniqueOpens(list) {
      return list.map((elm) => {
        return {
          recipientId: elm.recipientId,
          email: elm.email,
          open: elm.openCount,
          click: elm.clickCount,
          sender: elm.sender ?? '',
          sentDate: elm.sentDateTime ? dateTimeFormatString(elm.sentDateTime, null, null, false) + ` (${this.timezone})` : '',
        }
      })
    },

    editClicks(list) {
      return list.map((elm) => {
        return {
          recipientId: elm.recipientId,
          email: elm.email,
          clicks: elm.clickCount,
          open: elm.openCount,
          sender: elm.sender ?? '',
          sentDate: elm.sentDateTime ? dateTimeFormatString(elm.sentDateTime, null, null, false) + ` (${this.timezone})` : '',
        }
      })
    },

    editUniqueClicks(list) {
      return list.map((elm) => {
        return {
          recipientId: elm.recipientId,
          link: elm.link,
          'Unique Clicks': elm.uniqueClicks,
          'Total Clicks': elm.totalClicks,
          sender: elm.sender ?? '',
          sentDate: elm.sentDateTime ? dateTimeFormatString(elm.sentDateTime, null, null, false) + ` (${this.timezone})` : '',
        }
      })
    },

    editBounced(list) {
      return list.map((elm) => {
        return {
          email: elm.email,
          bounced: elm.bounced,
          sender: elm.sender ?? '',
          sentDate: elm.sentDateTime ? dateTimeFormatString(elm.sentDateTime, null, null, false) + ` (${this.timezone})` : '',
          error: elm.error,
          error_related_to: elm.errorRelatedTo,
        }
      })
    },

    editMarkedAsSpam(list) {
      return list.map((elm) => {
        return {
          email: elm.email,
        }
      })
    },

    editUnsubscribes(list) {
      return list.map((elm) => {
        return {
          recipientId: elm.recipientId,
          email: elm.email,
          open: elm.openCount,
          click: elm.clickCount,
          sender: elm.sender ?? '',
          sentDate: elm.sentDateTime ? dateTimeFormatString(elm.sentDateTime, null, null, false) + ` (${this.timezone})` : '',
        }
      })
    },

    editPending(list) {
      return list.map((elm) => {
        let status = elm.dlrStatus + ''
        return {
          phone: elm.msisdn,
          sender: elm.sender ?? '',
          countryId: elm.countryId,
          message: elm.text,
          sentDate: elm.sentDateTime ? dateTimeFormatString(elm.sentDateTime, null, null, false) : '',
          status: dlrStatus[status],
          deliveryDate: elm.deliveryReportUpdateDateTime ? dateTimeFormatString(elm.deliveryReportUpdateDateTime, null, null, false) : '',
          deliveryDescription: elm.deliveryReportDescription ?? '',
          totalSegments: elm.totalSegments ?? '',
        }
      })
    },

    editDelivered(list) {
      return list.map((elm) => {
        let status = elm.dlrStatus + ''
        return {
          phone: elm.msisdn,
          sender: elm.sender ?? '',
          countryId: elm.countryId,
          message: elm.text,
          sentDate: elm.sentDateTime ? dateTimeFormatString(elm.sentDateTime, null, null, false) : '',
          status: dlrStatus[status],
          deliveryDate: elm.deliveryReportUpdateDateTime ? dateTimeFormatString(elm.deliveryReportUpdateDateTime, null, null, false) : '',
          deliveryDescription: elm.deliveryReportDescription ?? '',
          totalSegments: elm.totalSegments ?? '',
        }
      })
    },

    editNotDelivered(list) {
      return list.map((elm) => {
        let status = elm.dlrStatus + ''
        return {
          phone: elm.msisdn,
          sender: elm.sender ?? '',
          countryId: elm.countryId,
          message: elm.text,
          sentDate: elm.sentDateTime ? dateTimeFormatString(elm.sentDateTime, null, null, false) : '',
          status: dlrStatus[status],
          deliveryDate: elm.deliveryReportUpdateDateTime ? dateTimeFormatString(elm.deliveryReportUpdateDateTime, null, null, false) : '',
          deliveryDescription: elm.deliveryReportDescription ?? '',
          totalSegments: elm.totalSegments ?? '',
        }
      })
    },

    editRecipients(list) {
      return list.map((elm) => {
        return {
          email: elm.to,
        }
      })
    },

    onTableChange() {
      this.getData()
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    getFlag(data) {
      const item = nameCountries(this).filter((item) => item.value.toUpperCase() == data.toUpperCase())
      if (item[0]) {
        return { ...item[0] }
      }
      return ''
    },
  },
}
</script>
<style scoped lang="scss">
.listItem__download {
  cursor: pointer;
}

.listItem__name {
  flex: 0 0 20%;
  min-width: 250px;
}

.listItem__numbers {
  font-size: $font-size-xs;
  position: relative;
}

.listItem__detail {
  flex-wrap: wrap;
}

.listItem__detailItem {
  flex: 0 0 25%;
  margin-bottom: 2%;

  &.big {
    flex: 0 0 50%;
  }
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
